import "./sentry";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { ThemeProvider } from "@mui/material";
import { theme } from "./assets/theme.ts";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n.ts";
import { Provider } from "react-redux";
import { store } from "./app/store.ts";
import ErrorBoundaryProvider from "./context/ErrorBoundaryProvider";
import * as Sentry from "@sentry/react";

const container = document.getElementById("root")!;

const root = createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn("Uncaught error", error, errorInfo.componentStack);
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <ErrorBoundaryProvider>
            <App />
          </ErrorBoundaryProvider>
        </Provider>
      </I18nextProvider>
    </ThemeProvider>
  </StrictMode>
);
